/**
 * Sizing shared by every control a tool input can render into.
 *
 * Its own module rather than a constant in the inputs editor: the custom
 * per-tool controls need it too, and they are imported *by* that editor, so
 * reaching back into it would close an import cycle.
 */

/**
 * One height for every single-line control in a field row.
 *
 * A row holds whatever box its field's type calls for — text, number, select,
 * dataset picker — and each of those components ships its own default height.
 * Left alone they stack at three different sizes down the panel. The value is
 * the token input's, since that is the control most fields get.
 */
export const TOOL_INPUT_CONTROL_HEIGHT = 'h-8';

/** The JSON box, styled as the bordered inputs beside it rather than a bare textarea. */
export const TOOL_INPUT_JSON_CLASS =
  'border-input focus-visible:border-ring focus-visible:ring-ring/50 min-h-[72px] w-full resize-y rounded-md border bg-transparent px-3 py-1.5 font-mono text-xs shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px]';
